'use client';

import type { ClassWithCourse } from '@peach/types/classes/class-public.dto.js';
import type { CourseWithBundle } from '@peach/types/courses/course-public.dto.js';
import { useTimezone } from '@/lib/hooks/useTimezone';
import { CallCard } from './CallCard';
import { PassCard } from './PassCard';

interface EarlierCallsProps {
  calls: ClassWithCourse[];
  passes: CourseWithBundle[];
  tutorUsername: string;
  tutorName: string;
  userProfile: { name: string | null; username: string | null } | null;
  serverNow: number;
  initialTimezone: string | null;
}

/**
 * A client's calls and passes from before the creator moved to subscriptions.
 * The zone is resolved here, on the client: a server cookie alone is missing on a
 * first visit, and CallCard would then stand as a skeleton for good.
 */
export function EarlierCalls({
  calls,
  passes,
  tutorUsername,
  tutorName,
  userProfile,
  serverNow,
  initialTimezone,
}: EarlierCallsProps) {
  const timezone = useTimezone(initialTimezone);
  return (
    <>
      {calls.map((cls) => (
        <CallCard
          key={cls.id}
          cls={cls}
          tutorUsername={tutorUsername}
          timezone={timezone}
          serverNow={serverNow}
        />
      ))}
      {passes.map((course) => (
        <PassCard
          key={course.id}
          course={course}
          tutorUsername={tutorUsername}
          tutorName={tutorName}
          userProfile={userProfile}
          serverNow={serverNow}
        />
      ))}
    </>
  );
}
